import api from "../../services/axios";

function onlyDigits(s) {
  return String(s || "").replace(/\D/g, "");
}

/** Separa DDD e restante a partir de telefone mascarado (ex.: (11) 99999-9999). */
function splitDddNumero(telefoneFormatado) {
  const d = onlyDigits(telefoneFormatado);
  if (d.length >= 10) {
    return { ddd: d.slice(0, 2), numero: d.slice(2) };
  }
  return { ddd: "", numero: d };
}

const ATIVIDADES_INTERESSE_LABELS = {
  gastronomia: "Gastronomia",
  esportes: "Esportes",
  cinema: "Cinema",
  viagens: "Viagens",
  leitura: "Leitura",
};

function formatHobbyFromForm(form) {
  const atividade = String(form.atividadeInteresse || "").trim();
  if (!atividade) return "";

  if (atividade === "outros") {
    const texto = String(form.atividadeInteresseOutros || "").trim();
    return texto ? `Outros: ${texto}` : "";
  }

  return ATIVIDADES_INTERESSE_LABELS[atividade] || atividade;
}

/**
 * Credenciamento participante 2026 → mesmo endpoint do cadastro legado.
 * POST /usuarios-create (multipart): UsuariosController.create
 *
 * @param {object} form — estado do formulário Credenciamento2026
 * @param {File | null | undefined} bioFoto — foto da bio (avatar), opcional
 * @param {{ conteudo1?: number|null, conteudo2?: number|null, empresaInteresse?: string }} [escolhas] — conteúdos e Match & Meet
 * @returns {Promise<{ ok: boolean; protocolo: string; mensagem: string }>}
 */
export async function submitCredenciamento2026(form, bioFoto, escolhas = {}) {
  const formData = new FormData();

  const nomeCracha = String(form.nomeCracha || "").trim();
  const { ddd: dddCom, numero: telCom } = splitDddNumero(form.telComercial);

  formData.append("nome", nomeCracha);
  formData.append("nome_cracha", nomeCracha);
  formData.append("cpf", form.cpf);
  formData.append(
    "dt_nascimento",
    String(form.dataNascimento || "").split("/").reverse().join("-")
  );
  formData.append("email", String(form.email || "").trim());
  formData.append("tipo", "convidado");
  formData.append("bio", String(form.bioCurta || "").trim());
  formData.append("atividade_interesse", "");
  formData.append("celular", form.celular);
  formData.append("estado", String(form.estado || "").trim());
  formData.append("regiao", String(form.regiao || "").trim());
  formData.append("empresa", String(form.nomeInstituicao || "").trim());
  formData.append("cargo", String(form.cargo || "").trim());
  formData.append("sexo", String(form.sexo || "").toLowerCase());
  formData.append("ddd_comercial", dddCom);
  formData.append("telefone_comercial", telCom);
  formData.append("departamento", "");
  formData.append("nome_secretaria", String(form.secretaria || "").trim());
  formData.append("email_secretaria", String(form.emailSecretaria || "").trim());
  formData.append("telefone_secretaria", form.telSecretaria);
  formData.append("procura_sbf", form.procura);
  formData.append("outros_procura_sbf", String(form.outrosProcura || ""));
  formData.append("faturamento_instituicao", form.faturamento);
  formData.append("numero_leitos", String(form.leitos ?? ""));
  formData.append("numero_vidas", String(form.vidas ?? ""));
  formData.append("tipo_instituicao", form.segmento);
  formData.append("segmento_outros", String(form.segmentoOutros || ""));
  formData.append("hobby", formatHobbyFromForm(form));
  formData.append("prioridade", String(form.prioridade || ""));
  formData.append("transformacao", String(form.transformacao || ""));
  formData.append("sugestao_empresa", String(form.sugestaoEmpresa || "").trim());
  formData.append("acao_especial", form.acaoEspecial === "sim");
  formData.append("uso_imagem", Boolean(form.usoImagem));
  formData.append("termo1", form.aceiteRegulamento ? "Sim" : "Não");
  formData.append("termo2", "");

  const empresaInteresse = String(escolhas.empresaInteresse || "").trim();
  formData.append("empresa_interesse", empresaInteresse);

  if (escolhas.conteudo1 != null) {
    formData.append("conteudo1", String(escolhas.conteudo1));
  }
  if (escolhas.conteudo2 != null) {
    formData.append("conteudo2", String(escolhas.conteudo2));
  }

  if (bioFoto) {
    formData.append("avatar", bioFoto);
  }

  const resp = await api.post("/usuarios-create", formData, {
    skipAuth: true,
    headers: {
      "content-type": "multipart/form-data",
    },
  });

  const criado = resp.data?.dados?.novoUsuarioInserido;
  const id = criado?.id;
  const pin = criado?.pin;
  const protocolo =
    id != null
      ? pin
        ? `Inscrição nº ${id} — PIN ${pin}`
        : `Inscrição nº ${id}`
      : `SBF2026-${Date.now().toString(36).toUpperCase()}`;

  return {
    ok: true,
    protocolo,
    mensagem:
      resp.data?.mensagem ||
      "Credenciamento realizado. Verifique seu e-mail para criar sua senha.",
  };
}
